export default __webpack_public_path__ + "static/media/repeatingBackground.02252817.svg";